/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

const expiresInterval = 10 * 365 * 24 * 60 * 60;
const userDataStore = {
  get: function(key, defaultValue, expiration) {
    const {sessionStorage, localStorage} = window;

    if (sessionStorage && expiration === 'session') {
      return sessionStorage.getItem(key) || defaultValue;
    }

    if (localStorage) {
      if (hasExpired(localStorage.getItem(key))) {
        delete localStorage.removeItem(key);
      }

      return parseTimestampWrapperValue(localStorage.getItem(key)) || defaultValue;
    }

    return get.call(this, key, defaultValue);
  },
  put: function(key, value, expiration) {
    const {sessionStorage, localStorage} = window;

    if (sessionStorage && expiration === 'session') {
      return sessionStorage.setItem(key, value);
    }

    value = expiration ? getObjectWithTimestamp(value, expiration) : value;

    if (localStorage) {
      return localStorage.setItem(key, value);
    }

    return put.call(this, key, value, expiration);
  }
};

function getCookiesWithCaching() {
  if (this._cachedCookies) {
    return this._cachedCookies;
  }

  const cookies = document.cookie.split(';');
  this._cachedCookies = {};
  cookies.forEach((cookie) => {
    cookie = cookie.trim();

    const idx = cookie.indexOf('=');
    const key = cookie.substring(0, idx);

    this._cachedCookies[key] = cookie.substring(idx + 1);
  });

  return this._cachedCookies;
}

function get(key, defaultValue) {
  const cookies = getCookiesWithCaching.call(this);
  const value = parseTimestampWrapperValue(cookies[key]);

  if (!value && value !== '') {
    return defaultValue;
  }

  return decodeURIComponent(value);
}

function put(key, value, expires) {
  if (this._cachedCookies && this._cachedCookies[key] === value) {
    return;
  }

  const encodedValue = encodeURIComponent(value);

  document.cookie = key + '=' + encodedValue + '; expires=' + (expires || expiresInterval);

  if (this._cachedCookies) {
    this._cachedCookies[key] = value;
  }
}

function hasTimestampWrapper(value) {
  return typeof value === 'string' && value.includes('phenixExpiration');
}

function parseTimestampWrapperValue(value) {
  if (!hasTimestampWrapper(value)) {
    return value;
  }

  const parsedObject = JSON.parse(value);

  if (parseInt(parsedObject.phenixExpiration, 10) > new Date().getTime()) {
    return parsedObject.value;
  }
}

function hasExpired(value) {
  if (!hasTimestampWrapper(value)) {
    return false;
  }

  const parsedObject = JSON.parse(value);

  return parseInt(parsedObject.phenixExpiration, 10) <= new Date().getTime();
}

function getObjectWithTimestamp(value, expiration) {
  return JSON.stringify({
    value: value,
    phenixExpiration: new Date().getTime() + expiration
  });
}

export default userDataStore;